require('datatables.net-bs4');

$( document ).ready(function() {
  if($('[id^=phone_access_logs_dataTable_wrapper]').length == 0 && $('#phone_access_logs_dataTable').length > 0) {
    table = $('#phone_access_logs_dataTable').DataTable({
      dom: "<'row'<'col-6'l>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'float-right my-3'p>",
      pagingType: 'full_numbers',
      lengthMenu: [[10, 20, 50], ["10件", "20件", "50件"]],
      language: {
        emptyTable: "電話番号ボタンは登録されておりません",
        zeroRecords: "電話番号ボタンは登録されておりません",
        lengthMenu: "_MENU_ を表示する",
        paginate: {
          first: '<< 最初へ',
          last: '最後へ >>',
          next: '次へ >',
          previous: '< 前へ',
        }
      },
      order: [],
      autoWidth: false,
      drawCallback: function(settings) {
        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
        pagination.toggle(this.api().page.info().pages > 1);

        if($('.release_time').length > 0) {
          $('.release_time').each(function(index) {
            let dateString = $(this).html().replaceAll('-', '/');
            let date = new Date(dateString);
            date = date.toLocaleString('ja-JP', { year: 'numeric', month: "numeric",
                                                  day: "numeric", hour: "numeric",
                                                  minute: "numeric" })
            $(this).html(date)
          })
        }
      },
      stateSave: true
    });
  }
});
